import React from "react";
import { Layout } from "../components/Layout/Layout";



export default function LocationsPage() {
  return (
    <Layout>
      <div className="p-8">Locations Page</div>
    </Layout>
  );
}
